Cm.forms = {
    processForm: null,
    init: function() {
        $(document).on('submit', Cm.o('forms.subscribe.el'), function(e) {
            if(Cm.forms.isValid(this)) {
                Cm.forms.subscribe.submit($(this));
            }
            e.preventDefault();
            return false;
        });
    },
    subscribe: {
        submit: function($form) {
            const mailChimpUrl = 'https://camdenmarket.us4.list-manage.com/subscribe/post-json?u=78efecf01530132ed95849d8e&id=b074092387&v_id=2981&f_id=00b659e3f0';

            $(Cm.o('forms.subscribe.loaderEl')).removeClass('d-none');
            console.log( $form.serialize() );
            console.log( mailChimpUrl + '&c=?' );
            $.ajax({
                url: mailChimpUrl + '&c=?',
                data: $form.serialize(),
                dataType: 'jsonp',
                success: function(res, status) {
                    console.log(res);
                    if (res.result === 'error') {
                        $form.find(Cm.o('forms.errorClass')).addClass('d-block').removeClass('success').html(res.msg);
                    } else {
                        $form.find('.newsletter__textInput___iRN9M').val('');

                        if( $('.page-template-template-home-v2').length > -1 ) {
                            $form.find(Cm.o('forms.errorClass')).addClass('d-block success').css('color', '#000').text(res.msg);
                            dataLayer.push({'event' : 'newsletterSubmitted', 'formName' : 'Newsletter Form'});
                            setTimeout(function() {
                                $form.find(Cm.o('forms.errorClass')).removeClass('d-block success').css('color', '#000').text('');
                            }, 3000);
                        }

                        setTimeout( function() {
                            if( $('#subscribenow-modal').length > -1 ) {
                                $('#subscribenow-modal h5.center').html('').html("You're signed up!");
                                $('#subscribenow-modal input[name="EMAIL"]').prop('disabled', true);
                                $('#subscribenow-modal #checkFormBio').prop('disabled', true);
                                $('#subscribenow-modal button.newsletter__submitButton___1ph4C').addClass('disabled');
                                setTimeout( function() {
                                    $('#subscribenow-modal input[name="EMAIL"]').removeAttr('disabled');
                                    $('#subscribenow-modal #checkFormBio').removeAttr('disabled');
                                    $('#subscribenow-modal button.newsletter__submitButton___1ph4C').removeClass('disabled');
                                    $('#subscribenow-modal .close').trigger('click');
                                    $('.btn-subcribe').trigger('click');
                                    $('#subscribenow-modal h5.center').html('').html('Subscribe to @camdenmarketldn');
                                    $('#frm-site-subscribe')[0].reset();
                                }, 3000);
                            } else {
                                if (res.msg) {
                                    $form.find(Cm.o('forms.errorClass')).addClass('d-block success').text(res.msg);                            
                                } else {
                                    $form.find(Cm.o('forms.errorClass')).addClass('d-block success').text('Thank you for subscribing to our newsletter.');
                                }
                            }
                        }, 1000);
                    }
                },
                error: function(err, errmsg, errtext) {
                    $form.find(Cm.o('forms.errorClass')).addClass('d-block').text('Oops! Something went wrong. Please Try again.');
                },
                complete: function(response) {
                    $(Cm.o('forms.subscribe.loaderEl')).addClass('d-none');
                }
            });
        },
    },

    post: function(args) {
        return $.ajax($.extend({
            url: wp.ajax_url,
            type: 'post',
            data: {},
            dataType: 'json',
            success: function(response) { },
            fail: function(response) { },
        }, args)).always(function(response) {
            if(typeof args.always == 'function') {
                args.always(response);
            }
            
            if(Cm.forms.processForm) {
                Cm.forms.reset(Cm.forms.processForm);
                Cm.forms.processForm = null;
            }
        });
    },

    reset: function(form) {
        form.trigger('reset');
        form.trigger('form.submit');
    },

    isValid: function(form) {
        var valid = true, errC = 0;
        $(form).find('[data-validate]').each( function(i, el) {
            var validate_list = this.dataset.validate.split(' ');
            var inp = this, errState = false, hasValue = (this.value !== '');

            if(validate_list.indexOf('required') > -1 && !hasValue) {
                errState = true;
                $(inp).parent().find('.required-message').text('This is required')
            }

            // validate phone number.
            if(validate_list.indexOf('phone') > -1) {
                if(!errState && !Cm.o('forms.patterns.phone').test(this.value)) {
                    errState = true;
                }
            }

            // validate email address.
            if(validate_list.indexOf('email') > -1) {
                if(!errState && !Cm.o('forms.patterns.email').test(this.value)) {
                    errState = true;
                }
            }

            if(errState) {
                setTimeout( function() {
                    $(inp).addClass('newsletter__textInputError');
                    $(inp).closest('form').find(Cm.o('forms.errorClass')).addClass('d-block').removeClass('success').text('Please enter a valid e-mail address.');
                }, 20);

                valid = false;
                errC++;

                if(errC == 1) {
                    $(this).trigger('focus');
                }
            } else {
                setTimeout( function() {
                    $(inp).removeClass('newsletter__textInputError');
                    $(inp).closest('form').find(Cm.o('forms.errorClass')).removeClass('d-block');
                }, 20);
            }
        });

        return valid;
    }
};